"use client";

import { c as _c } from "react/compiler-runtime";
import { Locale } from "@/types/locale";
import { PropsWithClassName } from "@/types/ui";
import React, { FC } from "react";
import { useLocale } from "next-intl";
import { SwitchLanguageButton } from "./switch-language-button";

// Общая шапка входит в клиентскую оболочку, поэтому язык читается из её контекста.
export const SwitchLanguage: FC<PropsWithClassName> = props => {
  const $ = _c(3);
  const locale = useLocale();
  const t0 = locale as Locale;
  let t1;
  if ($[0] !== props || $[1] !== t0) {
    t1 = <SwitchLanguageButton locale={t0} {...props} />;
    $[0] = props;
    $[1] = t0;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};